export default __webpack_public_path__ + "static/media/trophy_black.2459d275.svg";